<div class="container" [class.dropdown-opened]="toOpen" (click)="showDropdown()">
  <div class="cover-container">
    <div class="cover-content">
      <span class="text">{{ coverText }}</span>
      <app-icon phosphorClass="ph-caret-down" [size]="Size.small"></app-icon>
    </div>
  </div>

  @if (toOpen) {
    <div class="dropdown-container">
      <div class="content" (click)="hasCloseOnCLick && hide()">
        <ng-content select="[dropdown-content]"></ng-content>
      </div>
    </div>
  }
</div>
